import { motion } from 'motion/react';
import { Profile } from '../../types/profile';
import { useNavigate } from 'react-router';
import { useProfile } from '../../hooks/useProfile';
import { generateDetailUrl } from "../../utils/urlUtils";
import { useStation } from '../../contexts/StationContext';
export const HeaderCarousel: React.FC<{ onClickProfile: (profile: Profile) => void }> = ({ onClickProfile }) => {
    const { profiles } = useProfile();
    const navigate = useNavigate();
    const { station } = useStation();
    const onClick = (profile: Profile) => {
        navigate(generateDetailUrl(station?.name || '', station.id || '', 'rjs', profile.name, profile.id));
        onClickProfile(profile);
    }

    return (
        <div className='flex justify-start lg:justify-center items-center'>
        <ul className="m-auto flex gap-4 p-4 overflow-auto [&::-webkit-scrollbar]:hidden">
            {
                profiles.map((profile, index) => (
                    <li key={index} className="flex shrink-0">
                        <button type="button" className="flex flex-col items-center gap-2 shrink-0 group" onClick={() => onClick(profile)}>
                            <motion.img src={profile.image} alt={profile.imageAlt || profile.name} className="w-[144px] h-[192px] rounded-[88px] object-cover border-2 border-white hover:saturate-150 transition-all duration-500 group-hover:rounded-3xl" />
                            <div className="relative text-white text-center text-sm font-bold">
                                <p className="relative">{profile.name}</p>
                                <div className="md:group-hover:visible invisible bg-white h-[1px] group-hover:w-full w-0 transition-all absolute left-1/2 -translate-x-1/2 duration-500"></div>
                            </div>
                        </button>
                    </li>
                ))
            }
        </ul>
        </div>
    )
}